import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import { Formik } from "formik";

import { PrimaryButtonIcon } from "@components/Button";
import Div from "@components/Div";
import Form from "@components/Form";
import Icon from "@components/Icon";
import { InputPassword } from "@components/Input";
import InputText from "@components/InputText";
import { LinkArrow } from "@components/Link";
import ProgressSpinner from "@components/ProgressSpinner";
import { TextMediumWeight } from "@components/Text";

import { INITIAL_VALUES } from "./LoginCredentialsForm.constants";
import { useLoginCredentialsForm } from "./LoginCredentialsForm.hooks";
import {
  LoginSchema,
  EMAIL,
  LOGIN_PASSWORD,
} from "./LoginCredentialsForm.schema";

const LoginCredentialsForm = ({ onSubmit, onError }) => {
  const { messages } = useIntl();
  const {
    handleLoginSubmit,
    handleOnInputChange,
    handleRedirectToForgotPassword,
    showInvalidDataError,
    isLoading,
  } = useLoginCredentialsForm({ onSubmit, onError });

  return (
    <>
      {isLoading && <ProgressSpinner />}
      <Formik
        enableReinitialize
        initialValues={INITIAL_VALUES}
        validationSchema={LoginSchema}
        onSubmit={handleLoginSubmit}
      >
        {formik => {
          const { values, isValid, dirty } = formik;

          return (
            <Form width={1}>
              <Div
                display="flex"
                flexDirection="column"
                alignItems="center"
                width={1}
              >
                <Div width={1}>
                  <InputText
                    curved
                    width={1}
                    placeholder={messages.placeholder_email_address}
                    value={values.email}
                    name={EMAIL}
                    formikProps={{
                      ...formik,
                      handleChange: handleOnInputChange.bind(
                        this,
                        formik.handleChange
                      ),
                    }}
                    label={messages.label_email}
                  />
                </Div>

                <InputPassword
                  name={LOGIN_PASSWORD}
                  value={values.login_password}
                  placeholder={messages.label_password}
                  onChange={handleOnInputChange.bind(this, formik.handleChange)}
                  formikProps={formik}
                  label={messages.label_password}
                  width={1}
                />

                {showInvalidDataError && (
                  <TextMediumWeight error mt={3}>
                    {messages.invalid_data}
                  </TextMediumWeight>
                )}

                <PrimaryButtonIcon
                  rounded
                  mt={3}
                  width={1}
                  maxWidth="200px"
                  height="40px"
                  label={messages.login}
                  disabled={!isValid || !dirty || isLoading}
                  type="submit"
                />

                <LinkArrow
                  mt={2}
                  label={messages.title_forgot_password}
                  onClick={handleRedirectToForgotPassword}
                  direction="left"
                >
                  <Icon ml={1} name="headerarrowright" />
                </LinkArrow>
              </Div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

LoginCredentialsForm.propTypes = {
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
};

export default LoginCredentialsForm;
